import React from 'react'
import validator from 'validator'

import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import PanelFieldLinkValue from './PanelFieldLinkValue'
import PanelFieldMarkdownValue from './PanelFieldMarkdownValue'
import PanelFieldPreValue from './PanelFieldPreValue'
import PanelFieldTextListValue from './PanelFieldTextListValue'
import PanelFieldTextValue from './PanelFieldTextValue'

const styles = (theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  field: {
    marginBottom: theme.spacing(1),
    wordBreak: 'break-word',
  },
})
const useStyles = makeStyles(styles)

const PanelFieldValueComponents = {
  link: PanelFieldLinkValue,
  markdown: PanelFieldMarkdownValue,
  pre: PanelFieldPreValue,
  text: PanelFieldTextValue,
  textList: PanelFieldTextListValue,
}

export default function PanelField(props) {
  const { title, type = 'pre', value, valueLabel } = props

  const classes = useStyles()

  if (!value) {
    return null
  }

  if (Array.isArray(value)) {
    if (value.length <= 0) {
      return null
    }
  } else if (validator.isEmpty(value)) {
    return null
  }

  const PanelFieldValueComponent = PanelFieldValueComponents[type]

  return (
    <div className={classes.field}>
      {!!title && (
        <Typography variant="body2">
          <b>{title}</b>
        </Typography>
      )}

      <PanelFieldValueComponent value={value} valueLabel={valueLabel} />
    </div>
  )
}
